import { ReactElement } from 'react'
import styled from 'styled-components'
import { I18n, VITE_EXPERIAN_AUTOCHECK_BASE_URL } from 'common'
import { ArrowOutward } from '@mui/icons-material'
import { breakpoints } from '../theme/breakpoints'

interface IAutoCheckImageProps {
  vin?: string
  size?: 'small' | 'medium' | 'large'
  className?: string
}

// eslint-disable-next-line react-refresh/only-export-components
export const handleAutoCheck = (vin: string): void => {
  const vinParameter = vin ? `&vin=${vin}` : ''
  const url = VITE_EXPERIAN_AUTOCHECK_BASE_URL + vinParameter
  window.open(url, '_blank', 'noopener,noreferrer')
}

export const AutoCheckImage = (props: IAutoCheckImageProps): ReactElement => {
  const { vin, size = 'medium', className } = props

  return (
    <AutoCheckContainer
      onClick={() => handleAutoCheck(vin)}
      size={size}
      className={className}
    >
      <LogoImage src="/assets/AutoCheck.png" alt="AutoCheck" size={size} />
      <ActionText size={size}>
        <I18n name="getReport" />
      </ActionText>
      <ArrowOutward style={{ width: getArrowSize(size) }} />
    </AutoCheckContainer>
  )
}

const getArrowSize = (size: 'small' | 'medium' | 'large'): string => {
  switch (size) {
    case 'small':
      return '14px'
    case 'medium':
      return '18px'
    case 'large':
      return '20px'
    default:
      return '16px'
  }
}

const getContainerDimensions = (size: 'small' | 'medium' | 'large') => {
  switch (size) {
    case 'small':
      return { width: '168px', height: '31px' }
    case 'medium':
      return { width: '225px', height: '48px' }
    case 'large':
      return { width: '280px', height: '56px' }
    default:
      return { width: '225px', height: '48px' }
  }
}

const getLogoDimensions = (size: 'small' | 'medium' | 'large') => {
  switch (size) {
    case 'small':
      return { width: '64px', height: '23px' }
    case 'medium':
      return { width: '89px', height: '32px' }
    case 'large':
      return { width: '110px', height: '40px' }
    default:
      return { width: '89px', height: '32px' }
  }
}

const getFontSize = (size: 'small' | 'medium' | 'large') => {
  switch (size) {
    case 'small':
      return '12px'
    case 'medium':
      return '14px'
    case 'large':
      return '16px'
    default:
      return '14px'
  }
}

interface SizeProps {
  size: 'small' | 'medium' | 'large'
}

const AutoCheckContainer = styled.div<SizeProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: ${(props) => getContainerDimensions(props.size).width};
  height: ${(props) => getContainerDimensions(props.size).height};
  background-color: #ebebeb;
  cursor: pointer;
  padding: 0 15px 0 0;

  &:hover {
    background-color: #e0e0e0;
  }
`

const LogoImage = styled.img<SizeProps>`
  width: ${(props) => getLogoDimensions(props.size).width};
  height: ${(props) => getLogoDimensions(props.size).height};
  margin-left: 15px;

  @media screen and (width < ${breakpoints.tabletLarge}px) {
    width: ${(props) => (props.size === 'small' ? '64px' : '90px')};
    height: ${(props) => (props.size === 'small' ? '23px' : '40px')};
    margin-left: ${(props) => (props.size === 'small' ? '10px' : '15px')};
  }
`

const ActionText = styled.span<SizeProps>`
  font-family: Oswald, serif;
  font-style: normal;
  font-weight: bold;
  font-size: ${(props) => getFontSize(props.size)};
  line-height: ${(props) => getFontSize(props.size)};
  text-transform: uppercase;
  color: #000000;
  user-select: none;
  flex: 1;
  text-align: center;
`
